import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busrentalsforcorporateeventsinpune() {



  const cardData =
  {
    keyword: 'Bus Rental for Corporate Events in Pune',
    heading: 'Amruta Travels: Bus Rental for Corporate Events in Pune',
    headingDescription: 'Amruta Travels Pvt. Ltd. offers premium Bus Rental for Corporate Events in Pune, providing seamless and professional transport solutions for business meetings, conferences, off-site trips, and corporate outings. Our fleet includes luxury AC coaches, mini-buses, and 35 to 50-seater buses, designed to ensure a smooth and comfortable journey for employees, clients, and delegates. Each vehicle is equipped with plush push-back seats, air conditioning, and ample legroom, ensuring relaxation even on long routes. With professional chauffeurs, punctual service, and customized pickup options across Hinjewadi, Baner, Kharadi, and Pimpri Chinchwad, we make corporate travel efficient and hassle-free. Choose Amruta Travels’ Corporate Bus Rental in Pune for reliable, safe, and high-quality transportation that reflects your company’s professionalism.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
    {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark, visited by millions of devotees annually. Its magnificently decorated Lord Ganesha idol radiates devotion and serenity. During Ganesh Chaturthi, the temple comes alive with lights, chants, and celebrations. It stands as Pune’s beacon of faith and divine grace in the heart of the city."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched on a rugged hill about 30 km from the city, Sinhagad Fort offers breathtaking views of the Sahyadri ranges. The fort is famed for the heroic battle led by Tanaji Malusare under Chhatrapati Shivaji Maharaj’s command. Visitors enjoy trekking, exploring ancient ruins, and savoring local snacks like pithla-bhakri. Sinhagad Fort embodies Pune’s valor, nature, and nostalgia in one frame."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine carved out of basalt in the 8th century. Dedicated to Lord Shiva, the temple’s circular Nandi pavilion and stone pillars display remarkable craftsmanship. Nestled in the city center, it provides a tranquil escape from urban life. Pataleshwar Temple connects modern Pune to its timeless spiritual legacy."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering a blend of spirituality and scenic beauty. The temple complex atop the hill, dedicated to Lord Shiva and Goddess Parvati, was built by the Peshwas. Climbing its 108 steps rewards visitors with panoramic city views and a peaceful ambiance. Parvati Hill is Pune’s perfect fusion of devotion, history, and natural charm."
  },
    {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is an architectural masterpiece and a national monument of India’s freedom movement. Constructed in 1892, it served as a detention site for Mahatma Gandhi and his associates during the Quit India Movement. The palace’s sprawling gardens, museum, and Gandhi memorial exude peace and history. It is Pune’s enduring tribute to the nation’s struggle for independence."
  },
   {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada stands as the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas. Once the seat of the Maratha Empire, it boasts grand gates, intricately carved arches, and sprawling courtyards. The evening light and sound show vividly narrates tales of valor and tragedy. With its rich history and majestic aura, Shaniwar Wada remains the soul of Pune’s cultural identity."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of over 20,000 rare artifacts collected from across India. From musical instruments to traditional ornaments and sculptures, it offers a fascinating glimpse into India’s past. Each exhibit tells a story of art, culture, and human creativity. It’s a must-visit cultural gem for those exploring Pune’s heritage."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a serene sanctuary that draws visitors from all over the world. Set amid lush gardens and modern architecture, it offers meditation, wellness programs, and personal growth workshops. The peaceful environment helps people reconnect with their inner selves. Osho Ashram is Pune’s global destination for spirituality and transformation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a picturesque reservoir surrounded by rolling hills and greenery, just a short drive from Pune. It’s the main water source for the city and a favorite spot for picnics and evening drives. The scenic view of shimmering waters during sunset is mesmerizing. Khadakwasla offers Pune residents the perfect weekend retreat close to nature."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "The Pune Okayama Friendship Garden, inspired by Japan’s famous Korakuen Garden, blends Japanese landscaping with Indian flora. Its lush lawns, small bridges, flowing streams, and walking paths create a soothing environment for relaxation. Named after writer Pu La Deshpande, it’s ideal for families and photographers alike. The garden represents Pune’s bond of global friendship and aesthetic beauty."
  }
],



    "services": [
    {
      "name": "Bus Rental for Corporate Events in Pune",
      "description": "Bus Rental for Corporate Events in Pune offers specialized transportation solutions for business gatherings, conferences, team outings, and corporate functions. The service includes a fleet of well-maintained buses equipped with modern amenities, ensuring comfortable and punctual travel. Professional drivers and flexible rental packages help companies manage their event logistics smoothly and efficiently."
    },
    {
      "name": "Corporate Bus Hire Pune",
      "description": "Corporate Bus Hire Pune provides reliable and professional bus rental services tailored to corporate needs. Whether for daily employee transport or special corporate events, the service ensures clean, comfortable vehicles and courteous drivers who understand the importance of punctuality and professionalism in business travel."
    },
    {
      "name": "Corporate Staff Transport Pune",
      "description": "Corporate Staff Transport Pune focuses on efficient and safe transportation solutions for employees. Offering shuttle services, daily commutes, and special trip arrangements, this service prioritizes timely pickups and drop-offs, helping companies maintain smooth operational flow while ensuring employee convenience and safety."
    },
    {
      "name": "Office Bus Hire Pune",
      "description": "Office Bus Hire Pune specializes in providing buses for regular office commutes and business travel. Flexible scheduling, well-maintained vehicles, and experienced drivers enable companies to offer reliable transportation for their workforce, reducing travel stress and improving punctuality."
    },
    {
      "name": "Employee Shuttle Bus Pune",
      "description": "Employee Shuttle Bus Pune offers tailored shuttle services designed to meet the specific commuting needs of corporate employees. With scheduled routes, comfortable buses, and professional drivers, this service ensures seamless and stress-free travel for daily office commutes and corporate events."
    },
    {
      "name": "Corporate Event Bus Hire Pune",
      "description": "Corporate Event Bus Hire Pune provides dedicated buses for corporate meetings, conferences, product launches, and team-building activities. These buses are equipped with premium features and driven by skilled chauffeurs to ensure timely arrivals and departures, enhancing the overall event experience."
    },
    {
      "name": "Luxury Corporate Bus Pune",
      "description": "Luxury Corporate Bus Pune offers high-end buses featuring plush interiors, advanced amenities, and superior comfort tailored for executive travel and VIP corporate events. The service combines elegance with professionalism, delivering a premium transport experience that reflects the stature of your business."
    },
    {
      "name": "AC Corporate Bus Pune",
      "description": "AC Corporate Bus Pune ensures a cool and comfortable journey with fully air-conditioned buses ideal for Pune’s climate. Perfect for corporate trips and staff commutes, these buses feature modern AC systems and spacious seating to maintain a pleasant travel environment throughout the journey."
    },
    {
      "name": "Corporate Bus Rental in Hinjewadi",
      "description": "Corporate Bus Rental in Hinjewadi caters specifically to the IT and corporate hub, providing buses for employee transportation, client visits, and business events. The service offers punctual pickups, clean vehicles, and drivers familiar with local traffic to optimize travel efficiency within this busy area."
    },
    {
      "name": "Corporate Bus Rental in Hadapsar",
      "description": "Corporate Bus Rental in Hadapsar provides tailored bus rental services to businesses in the Hadapsar region. From daily staff shuttles to event transportation, the service ensures reliable, safe, and comfortable travel with a fleet maintained to high standards and professional drivers."
    },
    {
      "name": "Corporate Travel Bus Pune",
      "description": "Corporate Travel Bus Pune specializes in bus rentals for business trips, outstation travel, and client meetings. The service offers well-equipped buses and experienced drivers who ensure smooth, timely journeys, allowing corporate clients to focus on their business objectives without transportation worries."
    },
    {
      "name": "Corporate Outing Bus Pune",
      "description": "Corporate Outing Bus Pune provides transportation solutions for company picnics, team-building activities, and offsite events. These buses are spacious, comfortable, and operated by professional drivers who ensure safe and enjoyable group travel, fostering team spirit and convenience."
    },
    {
      "name": "Conference Bus Hire Pune",
      "description": "Conference Bus Hire Pune offers specialized bus rental services for corporate conferences and seminars. With a focus on punctuality and comfort, these buses accommodate group transportation needs efficiently, ensuring attendees arrive relaxed and on time for important business events."
    },
    {
      "name": "Affordable Corporate Bus Pune",
      "description": "Affordable Corporate Bus Pune provides budget-friendly corporate bus rental options without compromising on safety or quality. This service is ideal for startups, SMEs, and organizations looking to manage travel costs while maintaining professional and reliable transportation for their teams."
    },
    {
      "name": "Executive Bus Rental Pune",
      "description": "Executive Bus Rental Pune offers premium buses designed for high-level corporate travel, including executive meetings, VIP transport, and client hospitality. Featuring luxurious interiors and exceptional service, this option ensures a refined and impressive travel experience for business leaders."
    },
    {
      "name": "Volvo Corporate Bus Pune",
      "description": "Volvo Corporate Bus Pune provides state-of-the-art Volvo buses known for their comfort, safety, and smooth rides. These buses are ideal for long-distance corporate travel, executive transfers, and premium group transport, combining luxury with reliability for discerning corporate clients."
    },
    {
      "name": "35 Seater Corporate Bus Pune",
      "description": "35 Seater Corporate Bus Pune offers mid-sized bus rental options suited for corporate groups needing comfortable seating with ample space. Perfect for office staff transportation, client visits, and small corporate events, these buses are maintained to high standards and driven by professional chauffeurs."
    },
    {
      "name": "Corporate Bus Booking Pune",
      "description": "Corporate Bus Booking Pune provides a seamless and convenient platform for reserving corporate buses online. With instant confirmations, multiple vehicle options, and flexible scheduling, this service simplifies the process of organizing corporate transportation, ensuring a hassle-free booking experience."
    }
  ],
  "tableData": [
    ["Bus Rental for Corporate Events in Pune", "Corporate Bus Hire Pune"],
    ["Corporate Staff Transport Pune", "Office Bus Hire Pune"],
    ["Employee Shuttle Bus Pune", "Corporate Event Bus Hire Pune"],
    ["Luxury Corporate Bus Pune", "AC Corporate Bus Pune"],
    ["Corporate Bus Rental in Hinjewadi", "Corporate Bus Rental in Hadapsar"],
    ["Corporate Travel Bus Pune", "Corporate Outing Bus Pune"],
    ["Conference Bus Hire Pune", "Affordable Corporate Bus Pune"],
    ["Executive Bus Rental Pune", "Volvo Corporate Bus Pune"],
    ["35 Seater Corporate Bus Pune", "Corporate Bus Booking Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Bus Rental for Corporate Events in Pune",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd specializes in providing reliable bus rental services for corporate events in Pune, ensuring smooth and timely transportation for your team."
  },
  {
    "WhyChooseheading": "Wide Range of Bus Options",
    "WhyChoosedescription": "Choose from various seating capacities to accommodate small teams to large groups comfortably."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Our buses are regularly serviced and cleaned to maintain high standards of safety and hygiene."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Benefit from clear pricing structures with no hidden fees, ensuring budget-friendly transportation solutions."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Whether you need hourly, daily, or multi-day rentals, we tailor packages to fit your corporate event schedule."
  },
  {
    "WhyChooseheading": "Professional and Punctual Drivers",
    "WhyChoosedescription": "Our experienced drivers prioritize timely arrivals and courteous service to ensure a stress-free journey."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings, route planning, and any last-minute changes."
  },
  {
    "WhyChooseheading": "Easy and Efficient Booking Process",
    "WhyChoosedescription": "Book your corporate bus rental quickly online or via phone, with prompt vehicle dispatch across Pune."
  }
]





























  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer bus rental services for corporate events in Pune?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides reliable and comfortable bus rental services specifically for corporate events in Pune.',
  },
  {
    question: 'How can I book a bus for a corporate event in Pune with Amruta Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24×7 customer support team in Pune.',
  },
  {
    question: 'What types of buses are available for corporate event rentals in Pune?',
    answer: 'We offer a variety of buses including mini buses, 17 seater Urbania, 35 seater, 45 seater, 50 seater, and 53 seater buses to accommodate your corporate group size.',
  },
  {
    question: 'Are the drivers trained and experienced for corporate event bus rentals in Pune?',
    answer: 'Yes, all drivers are professional, courteous, and experienced in providing safe and comfortable rides for corporate events.',
  },
  {
    question: 'Can buses be hired for corporate meetings, team outings, airport transfers, and conferences in Pune?',
    answer: 'Absolutely. Our buses are perfect for corporate meetings, team outings, airport transfers, conferences, and other business-related travel needs.',
  },
  {
    question: 'Is the bus rental service for corporate events available 24×7 in Pune?',
    answer: 'Yes, Amruta Travels offers 24×7 availability for corporate event bus rentals in Pune to fit your schedule.',
  },
  {
    question: 'What safety and hygiene protocols are followed for corporate bus rentals?',
    answer: 'All vehicles are sanitized thoroughly before every trip, and drivers follow strict hygiene and safety measures.',
  },
  {
    question: 'What payment options are accepted for corporate event bus rentals in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available throughout the corporate bus rental period in Pune?',
    answer: 'Yes, our 24×7 customer support team is available to assist you anytime during your corporate bus rental.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Mehta',
    feedback: 'Amruta Travels provided excellent bus rental service for our corporate event in Pune. The vehicle was clean and the driver was professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neeta Kulkarni',
    feedback: 'Great experience with Amruta Travels for our team outing bus rental. Highly recommend their services for corporate events.',
    rating: 5,
  },
];


































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Rental for Corporate Events in Pune",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/15.jpg",
  "description": "Book Bus Rental for Corporate Events in Pune with Amruta Travels Pvt. Ltd. Offering luxury, AC, and executive buses for corporate staff transport, office shuttles, conferences, and corporate outings. Reliable and affordable corporate bus hire in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "16700"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/bus-rental-for-corporate-events-pune"
  }
};







  return (
    <div>
<Helmet>
  <title>Bus Rental for Corporate Events in Pune | Executive & Luxury Bus Hire | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Book Bus Rental for Corporate Events in Pune with Amruta Travels Pvt. Ltd. Choose from luxury, AC, and executive buses for corporate staff transport, office shuttles, conferences, and outings. Affordable and trusted corporate bus hire."
  />
  <meta
    name="keywords"
    content="Bus Rental for Corporate Events in Pune, Corporate Bus Hire Pune, Corporate Staff Transport Pune, Office Bus Hire Pune, Employee Shuttle Bus Pune, Corporate Event Bus Hire Pune, Luxury Corporate Bus Pune, AC Corporate Bus Pune, Corporate Bus Rental in Hinjewadi, Corporate Bus Rental in Hadapsar, Corporate Travel Bus Pune, Corporate Outing Bus Pune, Conference Bus Hire Pune, Affordable Corporate Bus Pune, Executive Bus Rental Pune, Volvo Corporate Bus Pune, 35 Seater Corporate Bus Pune, Corporate Bus Booking Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/15.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busrentalsforcorporateeventsinpune;